import { render, staticRenderFns } from "./IconStudentHat.vue?vue&type=template&id=4b5391ef"
import script from "./IconStudentHat.vue?vue&type=script&lang=js"
export * from "./IconStudentHat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports